// /api/projectService.js
import axios from './axiosInstance';

export default {
  // Get all projects with optional pagination
  getAllProjects(params = {}) {
    return axios.get('/projects/', { params });
  },

  // Search projects with query, page, and size parameters
  searchProjects(query, page = 1, size = 10) {
    return axios.get('/projects/search', {
      params: { query, page, size },
    });
  },
  getInterimProject() {
    return axios.get('/account/interim_project');
  },

  // Get a project by ID
  getProjectById(projectId) {
    return axios.get(`/projects/${projectId}`);
  },

  // Create a new project
  createProject(projectData) {
    return axios.post('/projects/', projectData);
  },

  // Update a project by ID
  updateProject(projectId, projectData) {
    return axios.put(`/projects/${projectId}`, projectData);
  },
  createProjectWithFiles(formData) {
    return axios.post('/projects/create_project_with_files', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  // Delete a project by ID
  deleteProject(projectId) {
    return axios.delete(`/projects/${projectId}`);
  },


};
